import React from "react";
import { useTreeState } from "../../../hooks/useTreeState";
import { useProfileState } from "../../../hooks/useProfileState";
import { useProjectState } from "../../../hooks/useProjectState";
import Box from "@mui/material/Box";
import ReactLoading from "react-loading";

// Ladebildschirm wenn Katalog/Profil lädt oder nach Aktualisierung keine Seite geladen ist

const LoadingText = () => {
  const tree = useTreeState();
  const profile = useProfileState();
  const project = useProjectState();
  const TreeClicked = tree.clicked;
  const ProfilClicked = profile.clicked;
  const ProjectClicked = project.clicked;

  if (TreeClicked) {
    return <p>Katalog wird geladen...</p>;
  } else if (ProfilClicked) {
    return <p>Profile werden geladen...</p>;
  } else if (ProjectClicked) {
    return <p>Projekte werden geladen...</p>;
  } else {
    return <p>Menü-Punkt auswählen...</p>;
  }
};

const LoadingScreen = () => {
  return (
    <div>
      <Box sx={{ marginTop: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <ReactLoading
          type={"spinningBubbles"}
          color={"#4D6F8C"}
          height={100}
          width={100}
        />
      </Box>
      <Box sx={{ marginTop: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <LoadingText />
      </Box>
    </div>
  );
};

export default LoadingScreen;
